function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M54.887.745C20.911 21.87 0 3.38 0 13.948c0 71.687 47.07 95.807 56.044 99.75a3.66 3.66 0 002.912 0C67.923 109.755 115 85.635 115 13.948 115 3.35 94.089 21.906 60.113.745a4.953 4.953 0 00-5.226 0z",
  fill: "#E60000",
  fillRule: "nonzero"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M57 0a4.877 4.877 0 00-2.59.723C20.73 21.874 0 3.385 0 13.953c0 71.677 46.66 95.794 55.557 99.736A3.6 3.6 0 0057 114V0z",
  fill: "#B20000",
  fillRule: "nonzero"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  fill: "#FFF",
  fillRule: "nonzero",
  x: 73,
  y: 28,
  width: 13,
  height: 44,
  rx: 5
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  fill: "#FFF",
  fillRule: "nonzero",
  x: 29,
  y: 46,
  width: 13,
  height: 26,
  rx: 5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M37.667 70.5h-4.334C30.94 70.5 29 68.485 29 66v1.5c0 2.485 1.94 4.5 4.333 4.5h4.334C40.06 72 42 69.985 42 67.5V66c0 2.485-1.94 4.5-4.333 4.5z",
  fillOpacity: 0.2,
  fill: "#1D1D1B",
  fillRule: "nonzero"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  fill: "#FFF",
  fillRule: "nonzero",
  x: 51,
  y: 37,
  width: 13,
  height: 35,
  rx: 5
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M54.887 2.186a4.974 4.974 0 015.226 0C93.674 23.003 114.476 5.242 115 14.993v-1.07C115 3.343 94.089 21.87 60.113.743a4.974 4.974 0 00-5.226 0C20.911 21.84 0 3.378 0 13.93V15c.524-9.722 21.333 8.003 54.887-12.814z",
  fill: "#FFF",
  fillRule: "nonzero",
  opacity: 0.2
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M59.667 70.5h-4.334C52.94 70.5 51 68.485 51 66v1.5c0 2.485 1.94 4.5 4.333 4.5h4.334C62.06 72 64 69.985 64 67.5V66c0 2.485-1.94 4.5-4.333 4.5zM81.667 70.5h-4.334C74.94 70.5 73 68.485 73 66v1.5c0 2.485 1.94 4.5 4.333 4.5h4.334C84.06 72 86 69.985 86 67.5V66c0 2.485-1.94 4.5-4.333 4.5z",
  fillOpacity: 0.2,
  fill: "#1D1D1B",
  fillRule: "nonzero"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M58.956 113.212a3.64 3.64 0 01-2.912 0C47.121 109.26.494 85.22 0 14v.35c0 72.115 47.07 96.38 56.044 100.346a3.64 3.64 0 002.912 0C67.923 110.73 115 86.466 115 14.35V14c-.488 71.221-47.114 95.26-56.044 99.212z",
  fill: "#1D1D1B",
  fillRule: "nonzero",
  opacity: 0.2
});

var SvgSecureNetHi = function SvgSecureNetHi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 126 126",
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 3)",
    fill: "none",
    fillRule: "evenodd"
  }, _ref, _ref2, /*#__PURE__*/React.createElement("image", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    },
    x: 66,
    y: 24,
    width: 26,
    height: 57,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAABOCAYAAABIb7SkAAAABGdBTUEAALGOGCHvlwAABIxJREFUaAXtmteOGzEMRXfTe0fy//+X3us6PDM6MqfK2ARBHiSAUGG7uqT9ojk/HA5n/9O4dlkw5zH2fOOil7rp+Sl+s+QZSF5nfBlMXZ8CchdQAUJShaSut8AIDCAKZ67BVUFq7LwKKDFyJQxJzDwXATkb02TMFyvi+dkasEUPzVi5GgEVbBH3gl0DZNJfYY/8LOI+tmeHyLUAtQCEZQySkBj9jSQ3Y329CHpBxbKODOZHnCLfQr4nieUAFNvJmAAq7JBEMAC4FXKnyO2y51y2sM+DMskKQL6GfAn5XGTCaOS8yKWbAAoHjGUHZgBzL+RBkfsx3w0BGEzhn1mSHUoEMwD5FPIh5H2I4LHTlnyVqQoo9Y4MAQhmAPM45GnIo5CHIZwDdg8QzMDKuxAuAOuMzCBM0kv8uAZQFdBgevxFcZ4BAeZ5yLMQwMEagGCJRJaBoCSBHQB9DIFRYjHQ0Uv2FEwCsI45IBQwxDl9ws0oE8wA5kXIkxBYQ0eitZKRlHJRJsF4RglhDsCWMJbjyIDsH0vG7WGBG1ImmAEMwCzbHkMkzWAAAsDMrJepfZQBhe1AfQYkS/SMzQ0YpMUQYBkwQ+mIgQ8xvYiA4mgcA6DS0JzMWUIvU9yMgAZmRpeD+svxovQSPvjKDLr8Hzb0n42tY9jUxnQtU9ggJKcEed4CFGYLW+NkMNgxNkumMjMFMMHl2XPm4ZYx+3+izuTOnhtfP/IOIzPkWZ6zY2utX8tuAUJHZhCfMnIS7N1v+Wa9a+bm2AJkEAKcFKiZaTQwVo4/cd0CNDH6l5sOqMV2Z6gz1GKgpe891BlqMdDS9x7qDLUYaOl7D3WGWgy09L2HOkMtBlr63kOdoRYDLX3voc5Qi4GWvvdQZ6jFQEvfe6gz1GKgpd/qIZ4IfCZwbsU6RW+sHH/itwVoYhQbAzQDFkft2brWt5isT623jhxsb230PZus034xrwHKjvnLBN5LfcDN5wT1yQDfrNvyyTnwryMDwshhYAL6VQKPcbwOOutL2eeAtMmzcQQ5zxdhxoe54XOH8qoocpnw/Z0HW8QPAni4Y7QegXl3xUd/ABIzgxqAbT2TZ2Zw5jlbELyb5ldm9ADjcS4zRDJ0gOHNHh98BUdM9BlUbMch7ezm7ODEzXhNJnB+f6d0rUdgn8lfh+2bEoNYxJwDGliK8+EtlTkPygWtssNnEibHzldmH3W3GCIxzADmZcjbEGIBlNjkINdkZIZQWDKMSQzNUE5SBmfckhdpAOG/1tT4A8iyAeZVCLE4I46AKjtxdmSIpuITjDizoQXknyc1twwwRv/sAaIs2HMBmAFMBlR7yIYO/REQmxgAQjAGkM0KSNmBmT/5XAfmiEUO88VyHJOSFZbmdRUgdYdumPHXlcs1RjyWnYSwhOALCIVyDQxlduJswRBnDEG4tqe4Hf2ECEYWsWV4a0tPYvwFwR7BbjH+u4/iVgEJu/x7w4CCyvWcGd2cZUom6n5eJh2YdwFpWIDVrQv80zovBcFZXe8B0fkkQBrneQYyq4b1KckXTnFwaUBrwf7G2W9EQvS7TbI9hQAAAABJRU5ErkJggg=="
  }), _ref3, /*#__PURE__*/React.createElement("image", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    },
    x: 23,
    y: 41,
    width: 26,
    height: 39,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAA2CAYAAACvHjsIAAAABGdBTUEAALGOGCHvlwAABFxJREFUWAntmdduHDEMRe303pH8//+l9+oNj0ZHy6kaOEGQhyVAqLFcXdKGRz4/HA5n/5NcuyyY85At37jopW56vsdvkjwDyfOML4Np8z0gNwFVICRVSep8DYzAAKKy5xxcDaTGjouAEiNXwpDEjFMVkKMxTcZ4saDuny0Bm/XQhJWrEVDFFnUt2CVAJv0V9ujPqq5jeXaIXDNQM0BYhpCExJzfSHoz5terci6omDbJYH7ELvot9HvSmBag2I5kBKiyQxLBAOBW6J2qt+uafdnCPgtlkhWAfA39Evq56ojRyHmRSzcCFA4Yyw7MAOZe6IOq92O8GwowmMI/syQ7lAhmAPIp9EPo+1DBY6ct+RpTDVDqHRkCEMwA5nHo09BHoQ9D2QfsFiCYgZV3oVwA1pHMIEzSS/xwFVANUDE9/kSxnwEB5nnos1DAwRqAYIlEloGgJIEdAH0MhVFiIZzRS/YUTAKwyRQQBzDEPn3CzSgTzADmReiTUFjjjERLJSMp5aJMgnGPEsIcgC1hTAfJgOwfS8btYYEbUiaYAQzALNsWQyTNYAACwMysl2l9lAGFbaE+A5IlesbmBgzaYwiwCMxQOmLgQ0wvIqDYGqQAqg3NzpQlzmWKmxHQwIyc5aD+5HhRegkffGWGs/w7rPSfja1j2LTGdC5T2KAkpwR5XAMUZjNb42Qw2CGrJfMwMwUwweXRfcZyyxj9feKZyR3dN75+5C2SGXIvj9mxN9evZzcDoSMjiPdIToK96zXffO6csStrgAxCgF2BupkGA2Pl+CPXNUAjo3+5OAHqsX1i6MRQj4He+amHTgz1GOidn3roxFCPgd75Wg/xp6h/jjr2Yu05N1aOP/JbAzQyioUBugGro/YsnetbTZaH3t/UOdjW3OhbNvlM+9m4BCg75hcwvst9KMj7BPVPU3zz2ZpPzoF/kwwII8XABPT1i48+vkId9aXsU0Da5NE4gpzmizDDB2B5VqtfryKXCd95eBhAfXjiAxHpPTbwfY+P/gAkZgZVgK09x2RmcObZRBB8n+fXDM4BxkdgZohknAGGtyF88BUcMTnPoGI5iLSzmrKDEzfj1YLA+Z2H0vUeG3yOeR22b2oMYhFzCqiwFPvlm50xC+WCVtnhOc7k2Pma4ePBGkMkhhnAvAx9G0osgBKbHOQaSWaIA0uGMYmhGcpJirDHLXn5ABD+S02NP4AsG2BehRKLPeIIqLETe0eGaCqe+mLPhhaQvzypuWWAMfpnCxBlwZ4LwAxgMqDWQzZ0nB8BsQgBEIoxgGxWQMoOzPzJszDMEYsc5ovpIKOSVZamdRUgdYdumPGnK5driHgsOwlhCcUXECrlKgxldmJvxhB7iCCc21Pcjn5CBSOL2CLe2tKTGH9BsEaxm8l/98+XRUDCrr+9YUDlyPmUGd0cZUom2npaJh0YNwFpWIG1pRP80zxPBcFem28B0XkXII3zOAGZj8p8T/KZU2xcGtBSsL+x9xu8vPSLTZbnZwAAAABJRU5ErkJggg=="
  }), _ref4, _ref5, /*#__PURE__*/React.createElement("image", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    },
    x: 45,
    y: 33,
    width: 26,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAABCCAYAAAA/rXTfAAAABGdBTUEAALGOGCHvlwAABHVJREFUaAXtmtduHDEMRe303pH8//+l9+oNj0ZHy6laOEGQhyFAqLFcXXL9oPH54XA4+5/k2mXBnIds+cZFL3XT81P8JskzkDzP+DKYNj8F5CagCoSkKkmdr4ERGEBU9pyDq4HU2HERUGLkShiSmHGqAnI0pskYLxbU/bMlYLMemrByNQKq2KKuBbsEyKS/wh79WdV1LM8OkWsGagYIyxCSkJjzG0lvxvx6Vc4FFdMmGcyP2EW/hX5PGtMCFNuRjABVdkgiGADcCr1T9XZdsy9b2GehTLICkK+hX0I/Vx0xGjkvculGgMIBY9mBGcDcC31Q9X6Md0MBBlP4Z5ZkhxLBDEA+hX4IfR8qeOy0JV9jqgFKvSNDAIIZwDwOfRr6KPRhKPuA3QIEM7DyLpQLwDqSGYRJeokfVwHVABXT4y+K/QwIMM9Dn4UCDtYABEsksgwEJQnsAOhjKIwSC+GMXrKnYBKATaaAOIAh9ukTbkaZYAYwL0KfhMIaZyRaKhlJKRdlEox7lBDmAGwJYzpIBmT/WDJuDwvckDLBDGAAZtm2GCJpBgMQAGZmvUzrowwobAv1GZAs0TM2N2DQHkOARWCG0hEDH2J6EQHF1iAFUG1odqYscS5T3IyABmbkLAf1l+NF6SV88JUZzvLfsNJ/NraOYdMa07lMYYOSnBLkcQ1QmM1sjZPBYIeslszDzBTABJdH9xnLLWP074lnJnd03/j6kbdIZsi9PGbH3ly/nt0MhI6MID5FchLsXa/55nPnjF1ZA2QQApwUqJtpMDBWjj9yXQM0MvqXix1Qj+2doZ2hHgO9872HdoZ6DPTO9x7aGeox0Dvfe2hnqMdA73zvoZ2hHgO9872HdoZ6DPTO13qIZxWfVhx7sU45N1aOP/JbAzQyioUBugGro/YsnetbTZaH3vtQDrY1N/qWTT7TfjYuAcqO+WsOb8w+eud9gvrMgm8+W/PJOfBvkgFhpBiYgH7J4QGTF1VHfSn7FJA2eTSOIKf5IszwmFk+EdWXWJHLhN8seORG/YjCYyfSezjnrRof/QFIzAyqAFv7tJCZwZlPAILgrTm/zHMOMB40M0Mk4wwwfOfAB1/BEZPzDCqWg0g7qyk7OHEzXuAJnL9ZULrew7mfFl6H7Zsag1jEnAIqLMV+eX9mzEK5oFV2+LRkcux8mfchfI0hEsMMYF6Gvg0lFkCJTQ5yjSQzxIElw5jE0AzlJEXY45a84gMI/6Wmxh9Alg0wr0KJxR5xBNTYib0jQzQVn61iz4YWkH88qbllgDH6ZwsQZcGeC8AMYDKg1kM2dJwfAbEIARCKMYBsVkDKDsz8ySdOmCMWOcwX00FGJassTesqQOoO3TDjryuXa4h4LDsJYQnFFxAq5SoMZXZib8YQe4ggnNtT3I5+QgUji9gi3trSkxh/QbBGsZvJf/ePBIuAhF3/esOAypHzKTO6OcqUTLT1tEw6MG4C0rACa0sn+Kd5ngqCvTbfAqLzSYA0zuMEZD4q81OSz5xi49KAloL9jb3fLu/0o+HpO8MAAAAASUVORK5CYII="
  }), _ref6, _ref7, _ref8, _ref9));
};

export default SvgSecureNetHi;